import { AddressLabel, AddressLabelLabels } from '@navio/nsdk';
import { entriesToOptions, getLabel, getLabelMapFromEntries } from 'noddi-util';
import { z } from 'zod';

export const ADDRESS_LABEL_OPTIONS = entriesToOptions(AddressLabel, AddressLabelLabels);

const ADDRESS_LABEL_TEXT = getLabelMapFromEntries(AddressLabel, AddressLabelLabels);

export const getAddressLabelText = (label: AddressLabel): string => getLabel(label, ADDRESS_LABEL_TEXT);

const ADDRESS_LABEL_VALUES = Object.values(AddressLabel) as [AddressLabel, ...AddressLabel[]];

const addressLabelShape = {
  label: z.enum(ADDRESS_LABEL_VALUES),
  customLabel: z.string()
};

const requireCustomLabel = (
  value: { label: AddressLabel; customLabel: string },
  context: { addIssue: (issue: { code: 'custom'; message: string; path: ['customLabel'] }) => void }
) => {
  if (value.label === AddressLabel.CUSTOM && !value.customLabel.trim()) {
    context.addIssue({ code: 'custom', message: 'Enter a label', path: ['customLabel'] });
  }
};

export const addressLabelFormSchema = z.object(addressLabelShape).superRefine(requireCustomLabel);

export type AddressLabelFormValues = z.input<typeof addressLabelFormSchema>;

// The patch updates the saved link. The street lives on Address and is not in the payload.
export const editAddressFormSchema = z
  .object({
    ...addressLabelShape,
    instructions: z.string()
  })
  .superRefine((value, context) => {
    requireCustomLabel(value, context);
  });

export type EditAddressFormValues = z.input<typeof editAddressFormSchema>;
